import { Params, QueryFn } from "./utils";

export const updateAccount: QueryFn = (params?: Params) => /* GraphQL */ `
  mutation ${params?.label || "UpdateAccount"}($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const determineRegistrationStatus = /* GraphQL */ `
  query DetermineRegistrationStatus(
    $input: RegistrationStatusControllerInput!
  ) {
    determineRegistrationStatus(input: $input) {
      isRecognized
      isCreated
      userStatus
      jwt
    }
  }
`;

export const registerCognitoUser = /* GraphQL */ `
  mutation RegisterCognitoUser($input: RegisterCognitoUserControllerInput!) {
    registerCognitoUser(input: $input) {
      status
    }
  }
`;

export const registerAppUser = /* GraphQL */ `
  mutation RegisterAppUser($input: RegisterAppUserControllerInput!) {
    registerAppUser(input: $input) {
      status
    }
  }
`;
